export const MAX_FILE_SIZE = 25e6; // 25MB
export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/pdf',
];
